export default __webpack_public_path__ + "static/media/wave.543277c6.svg";